function comboSymbol(event) {
  const name = String(event?.name || "").trim();
  const first = name.split(/\s+/)[0];
  if (first) return first;
  return String(event?.cur || "").trim();
}

function comboSide(event) {
  const name = String(event?.name || "").toUpperCase();
  if (event?.bull && !event?.bear) return "LONG";
  if (event?.bear && !event?.bull) return "SHORT";
  if (name.includes("SHORT")) return "SHORT";
  if (name.includes("LONG")) return "LONG";
  return "";
}

function comboContext(event) {
  const name = String(event?.name || "").trim();
  const existing = name.match(/\bCombo:\s*(.+)$/i);
  if (existing) return existing[1].trim();

  const desc = String(event?.desc || "");
  const match = desc.match(/([0-9A-Z+]+)\s+stretched\s+(below|above)\s+MA\/BB/i);
  if (!match) return "";
  return `${match[1].toUpperCase()} ${match[2].toLowerCase()} MA/BB -> 15M into BB`;
}

function setupHeaderTitle(event) {
  const setup = event?.setupChartContext;
  if (!setup) return "";

  const identity = [setup.currency, setup.direction, setup.status]
    .filter(Boolean)
    .map((value) => String(value).trim())
    .join(" ");
  const timeframe = String(setup.triggerTimeframe || "").replace(/^_/, "");
  const route = [setup.sourceLabel, timeframe && `${timeframe} reaction`]
    .filter(Boolean)
    .join(" → ");

  return [identity, route].filter(Boolean).join(" · ");
}

export function isComboEntryEvent(event, sectionTitle = "") {
  const haystack = `${event?.name || ""} ${sectionTitle || ""}`.toUpperCase();
  return haystack.includes("COMBO ENTRY") || haystack.includes("COMBO ENTRIES") || haystack.includes("COMBO:");
}

export function comboFeedLabel(event) {
  if (!isComboEntryEvent(event)) return event?.name || "";
  const context = comboContext(event);
  const prefix = [comboSymbol(event), comboSide(event)].filter(Boolean).join(" ");
  return context ? `${prefix} Combo: ${context}` : (event?.name || prefix);
}

export function comboHeaderTitle(event, sectionTitle) {
  const setupTitle = setupHeaderTitle(event);
  if (setupTitle) return setupTitle;
  if (!isComboEntryEvent(event, sectionTitle)) return sectionTitle;
  return comboFeedLabel(event) || sectionTitle;
}
